import {
  IDashboardResponse,
  IOverdueInvoicesResponse,
  IResponse,
  SessionContextType,
} from 'src/types';

import useFetch from 'src/hooks/useFetch';

export const FetchDashboard = (
  token: string,
  date: string,
  refreshSession: SessionContextType['refreshSession'],
): IResponse<IDashboardResponse> => {
  const { isLoading, isFetching, error, data, refetch } = useFetch<IDashboardResponse>({
    key: 'fetch-dashboard',
    url: `/owner/getDashboard?date=${date}`,
    headers: { 'x-access-token': token },
    enabled: true,
    onFailure: refreshSession,
  });

  return { isLoading, isFetching, error, data, refetch };
};

export const FetchOverdueInvoices = (
  token: string,
  date: string,
  refreshSession: SessionContextType['refreshSession'],
): IResponse<IOverdueInvoicesResponse> => {
  const { isLoading, isFetching, error, data, refetch } =
    useFetch<IOverdueInvoicesResponse>({
      key: 'get-overdue-invoices',
      url: `/owner/getOverdueInvoices?date=${date}`,
      headers: { 'x-access-token': token },
      enabled: false,
      onFailure: refreshSession,
    });

  return { isLoading, isFetching, error, data, refetch };
};
